import { render, staticRenderFns } from "./AppHighchart.vue?vue&type=template&id=04424f2e&scoped=true&"
import script from "./AppHighchart.vue?vue&type=script&lang=js&"
export * from "./AppHighchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04424f2e",
  null
  
)

export default component.exports